import { HttpLink, split } from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { getMainDefinition } from '@apollo/client/utilities';
import { createClient } from 'graphql-ws';
import { Kind, OperationTypeNode } from 'graphql';
import { DEFAULT_CLUSTER_CONNECTIONS } from 'config/index';

export type TransportLinkProps = {
  httpUri?: string;
  wsUri?: string;
};

const { graphqlUrl, graphqlWs } = DEFAULT_CLUSTER_CONNECTIONS;

export function createTransportLink({
  httpUri = graphqlUrl,
  wsUri = graphqlWs,
}: TransportLinkProps = {}) {
  const httpLink = new HttpLink({
    uri: httpUri,
    credentials: 'include',
    includeExtensions: true,
  });

  const wsLink = new GraphQLWsLink(
    createClient({
      url: wsUri,
    })
  );

  const transportLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === Kind.OPERATION_DEFINITION &&
        definition.operation === OperationTypeNode.SUBSCRIPTION
      );
    },
    wsLink,
    httpLink
  );

  return transportLink;
}
